export const noPointInfoStyle = { 
    height: '200px', 
    width: '200px'
}